import { Chart, Plugin } from 'chart.js';

export interface ICategoryXTicksPluginOptions {
  isMajorTick?: (label: string) => boolean;
  isMinorTick?: (label: string) => boolean;
  majorTickLength?: number;
  minorTickLength?: number;
  color?: string;
}

export function createCategoryXTicksPlugin(options: ICategoryXTicksPluginOptions = {}): Plugin {
  const { isMajorTick, isMinorTick, majorTickLength = 8, minorTickLength = 4, color = '#000' } = options;

  const drawTicks = (chart: Chart) => {
    const xScale = chart.scales['x'];
    if (!xScale) return;
    const ctx = chart.ctx;
    const y = xScale.top;
    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = 1;
    xScale.ticks.forEach((tick, index) => {
      const label = xScale.getLabelForValue(tick.value);
      const isMajor = isMajorTick ? isMajorTick(label) : true;
      if (!isMajor && isMinorTick && !isMinorTick(label)) return;
      const length = isMajor ? majorTickLength : minorTickLength;
      const x = xScale.getPixelForTick(index);
      ctx.beginPath();
      ctx.moveTo(x, y);
      ctx.lineTo(x, y + length);
      ctx.stroke();
    });
    ctx.restore();
  };

  return {
    id: 'categoryXTicks',
    beforeDraw: drawTicks,
  };
}
